var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "table-class": "text-nowrap",
      responsive: "",
      hover: "",
    },
    on: { "row-clicked": _vm.onClickRow },
    scopedSlots: _vm._u([
      {
        key: "cell(status)",
        fn: function (data) {
          return [
            _c(
              "span",
              {
                class: {
                  "text-danger": data.item.status === "Deleted",
                  "text-success": data.item.status === "Active",
                },
              },
              [_vm._v("\n      " + _vm._s(data.item.status) + "\n    ")]
            ),
          ]
        },
      },
      {
        key: "cell(level)",
        fn: function (data) {
          return [
            !data.item.level
              ? [_vm._v("Default")]
              : data.item.level === "info"
              ? _c("span", { staticClass: "info-color" }, [_vm._v("Info")])
              : data.item.level === "success"
              ? _c("span", { staticClass: "success-color" }, [
                  _vm._v("Success"),
                ])
              : data.item.level === "warning"
              ? _c("span", { staticClass: "warning-color" }, [
                  _vm._v("Warning"),
                ])
              : data.item.level === "error"
              ? _c("span", { staticClass: "error-color" }, [_vm._v("Error")])
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(start_date)",
        fn: function (data) {
          return [
            !data.item.start_date
              ? [_vm._v("-")]
              : [_vm._v(_vm._s(_vm.convertFromUtc(data.item.start_date, "L")))],
          ]
        },
      },
      {
        key: "cell(end_date)",
        fn: function (data) {
          return [
            !data.item.end_date
              ? [_vm._v("-")]
              : [_vm._v(_vm._s(_vm.convertFromUtc(data.item.end_date, "L")))],
          ]
        },
      },
      {
        key: "cell(created_by)",
        fn: function (data) {
          return [
            data.item.created_by
              ? _c(
                  "b-link",
                  {
                    attrs: {
                      to: {
                        name: "admin-user",
                        params: { id: data.item.created_by.id },
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(data.item.created_by.name) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(actions)",
        fn: function (data) {
          return [
            !data.item.is_deleted
              ? _c(
                  "b-btn",
                  {
                    attrs: { variant: "secondary" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("edit-clicked", data.item.id)
                      },
                    },
                  },
                  [_vm._v("\n      Edit\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "no-permission-wrapper",
              { attrs: { show: !_vm.canDeleteNotifications } },
              [
                !data.item.is_deleted
                  ? _c(
                      "b-btn",
                      {
                        attrs: {
                          variant: "danger",
                          disabled: !_vm.canDeleteNotifications,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("delete-clicked", data.item.id)
                          },
                        },
                      },
                      [_vm._v("\n        Delete\n      ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }